import React, { useMemo } from 'react'

import { environment } from '../../../../core/components'
import { useProductPageUrlParams } from '../../hooks'
import { ProductSkuRefText } from './ProductSkuRefText'

type SkuCache =
  | {
      refId: string
    }
  | undefined

export const ProductSkuRefLoading = () => {
  const { selectedSkuId } = useProductPageUrlParams()

  const refIdText = useMemo(() => {
    const store = environment.getStore().getSource()
    const skuCache = store.get(selectedSkuId) as SkuCache

    return skuCache?.refId
  }, [selectedSkuId])

  if (!refIdText) {
    return null
  }

  return <ProductSkuRefText>{refIdText}</ProductSkuRefText>
}
